import { apiClient } from "lib/apiClient";
import {
  IResearchAssignmentRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const assignResearchWorkItem = async (
  workItemId: string,
  request: IResearchAssignmentRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/work-items/${workItemId}/assignees`,
    request
  );
  return response.data;
};
